module.exports = __webpack_public_path__ + "img/115.f2598782.jpg";